<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
  >
    <path stroke="currentColor" stroke-width="2" d="M1 8h14" />
  </svg>
</template>
